import React, {useContext} from 'react'
import {EditedContext} from '../../../../partials/Context'

function About() {
  const edited = useContext(EditedContext)
  const {edited_item, input_value, setInputValue, lawyer_data, changeBtn, setEditedItem} = edited || '';
  const {about} = lawyer_data || ''
  const {about: input_about} = input_value || '';
  
  let about_length = 0;
  if(input_about) {
    about_length = input_about.length
  }
  return (
    <div id="about-me">
        <h3 className="title">
          O mnie&nbsp;
          <span className="description">
            {edited_item === 'about' ? `(${1000 - about_length} / 1000 znaków)` 
              : `(1000 znaków)`
            }
            </span>
          {changeBtn('about')}
        </h3>
          {edited_item === 'about' ?
            <textarea value={input_value.about} onChange={(e) => setInputValue({about: e.target.value})} maxLength="1000" id="about-text-area"></textarea>
            :
            <p id="about-content">
              {about ? <span className="about-value" onClick={()=>{setEditedItem('about'); setInputValue({about: about})}} >{about}</span> : 
              <span onClick={()=>{setEditedItem('about'); setInputValue({about: about})}} className="description">(Pole to jest bardzo ważne i wyświetlane jest w profilu. Powinno być napisane w pierwszej osobie. Może podsumowywać Państwa doświadczenie zawodowe i zainteresowania. Można wspomnieć jak Państwo budują relacje z klientem.<br/>
              Wskazówki jak pisać: "Koncentruje się na sprawach..."; "W mojej               praktyce kieruję się..."; "Z pełnym zaangażowaniem prowadzę               sprawy..." ; "Umiejętnie pomagam przy...")</span>
              }
            </p>
          }
    </div>
  )
}

export default About